export const POA_CALLBACK_ROUTE = '/__/poa_callback';

export const POA_CALLBACK_EVENT = 'POA_CALLBACK_EVENT';
